/**
 * Common two-part top-level domains (ccSLDs - country code second-level domains)
 * Used for domain normalization to correctly identify registrable domains
 */
export const COMMON_TWO_PART_TLDS = [
  // United Kingdom
  'co.uk', 'org.uk', 'net.uk', 'ac.uk', 'gov.uk', 'nhs.uk', 'police.uk', 'mod.uk',
  // Australia
  'com.au', 'net.au', 'org.au', 'edu.au', 'gov.au', 'asn.au', 'id.au',
  // New Zealand
  'co.nz', 'net.nz', 'org.nz', 'ac.nz', 'govt.nz', 'geek.nz', 'gen.nz', 'kiwi.nz', 'maori.nz', 'iwi.nz', 'school.nz',
  // South Africa
  'co.za', 'org.za', 'net.za', 'ac.za', 'gov.za', 'mil.za', 'edu.za',
  // Japan
  'co.jp', 'or.jp', 'ne.jp', 'ac.jp', 'ad.jp', 'ed.jp', 'go.jp', 'gr.jp', 'lg.jp',
  // Brazil
  'com.br', 'org.br', 'net.br', 'gov.br', 'edu.br', 'mil.br', 'art.br', 'b.br', 'det.br', 'dev.br', 'eco.br', 'emp.br', 'jor.br', 'jus.br', 'leg.br', 'mp.br', 'mus.br', 'not.br', 'ntr.br', 'odo.br', 'ppg.br', 'pro.br', 'psc.br', 'psi.br', 'rec.br', 'slg.br', 'srv.br', 'tmp.br', 'tur.br', 'tv.br', 'vet.br', 'zlg.br',
  // India
  'co.in', 'org.in', 'net.in', 'ac.in', 'edu.in', 'res.in', 'gov.in', 'mil.in', 'nic.in', 'firm.in', 'gen.in', 'ind.in', 'me.in',
  // Canada
  'co.ca', 'com.ca', 'net.ca', 'org.ca', 'gov.ca', 'ab.ca', 'bc.ca', 'mb.ca', 'nb.ca', 'nf.ca', 'nl.ca', 'ns.ca', 'nt.ca', 'nu.ca', 'on.ca', 'pe.ca', 'qc.ca', 'sk.ca', 'yk.ca',
  // China
  'com.cn', 'net.cn', 'org.cn', 'gov.cn', 'edu.cn', 'ac.cn', 'mil.cn', 'co.cn',
  // Germany
  'co.de', 'com.de',
  // France
  'co.fr', 'com.fr', 'asso.fr', 'nom.fr', 'prd.fr', 'presse.fr', 'tm.fr', 'aeroport.fr', 'assedic.fr', 'avocat.fr', 'avoue.fr', 'cci.fr', 'chambagri.fr', 'chirurgiens-dentistes.fr', 'experts-comptables.fr', 'geometre-expert.fr', 'gouv.fr', 'greta.fr', 'huissier-justice.fr', 'medecin.fr', 'notaires.fr', 'pharmacien.fr', 'port.fr', 'veterinaire.fr',
  // Israel
  'co.il', 'org.il', 'net.il', 'ac.il', 'gov.il', 'muni.il', 'idf.il',
  // Italy
  'co.it', 'com.it', 'org.it', 'net.it', 'edu.it', 'gov.it',
  // Netherlands
  'co.nl', 'com.nl', 'net.nl', 'org.nl', 'gov.nl',
  // Spain
  'com.es', 'nom.es', 'org.es', 'gob.es', 'edu.es',
  // Belgium
  'co.be', 'com.be', 'org.be', 'net.be', 'ac.be', 'gov.be',
  // Switzerland
  'co.ch', 'com.ch', 'org.ch', 'net.ch', 'gov.ch',
  // Austria
  'co.at', 'com.at', 'org.at', 'net.at', 'ac.at', 'gv.at', 'or.at',
  // Sweden
  'co.se', 'com.se', 'org.se', 'net.se', 'ac.se', 'pp.se', 'tm.se', 'brand.se', 'parti.se', 'press.se',
  // Norway
  'co.no', 'com.no', 'org.no', 'net.no', 'ac.no', 'gov.no', 'mil.no', 'stat.no', 'dep.no', 'kommune.no', 'herad.no', 'priv.no',
  // Denmark
  'co.dk', 'com.dk', 'org.dk', 'net.dk', 'ac.dk', 'gov.dk',
  // Finland
  'co.fi', 'com.fi', 'org.fi', 'net.fi', 'ac.fi', 'gov.fi',
  // Poland
  'co.pl', 'com.pl', 'net.pl', 'org.pl', 'gov.pl', 'edu.pl', 'mil.pl', 'waw.pl', 'krakow.pl', 'katowice.pl', 'poznan.pl', 'gdansk.pl', 'szczecin.pl', 'lublin.pl', 'bialystok.pl', 'czest.pl', 'slupsk.pl', 'radom.pl',
  // Czech Republic
  'co.cz', 'com.cz', 'org.cz', 'net.cz', 'ac.cz', 'gov.cz',
  // Hungary
  'co.hu', 'com.hu', 'org.hu', 'net.hu', 'ac.hu', 'gov.hu',
  // Russia
  'co.ru', 'com.ru', 'org.ru', 'net.ru', 'ac.ru', 'gov.ru', 'mil.ru', 'pp.ru', 'msk.ru', 'spb.ru',
  // Ukraine
  'co.ua', 'com.ua', 'org.ua', 'net.ua', 'ac.ua', 'gov.ua', 'pp.ua', 'kiev.ua', 'dp.ua', 'od.ua', 'kh.ua', 'dn.ua', 'lg.ua', 'mk.ua', 'nikolaev.ua', 'pl.ua', 'rv.ua', 'sumy.ua', 'te.ua', 'uz.ua', 'zp.ua', 'zt.ua',
  // South Korea
  'co.kr', 'com.kr', 'net.kr', 'org.kr', 'ac.kr', 'go.kr', 'mil.kr', 'ne.kr', 'or.kr', 'pe.kr', 're.kr', 'sc.kr', 'busan.kr', 'chungbuk.kr', 'chungnam.kr', 'daegu.kr', 'daejeon.kr', 'gangwon.kr', 'gwangju.kr', 'gyeongbuk.kr', 'gyeonggi.kr', 'gyeongnam.kr', 'incheon.kr', 'jeju.kr', 'jeonbuk.kr', 'jeonnam.kr', 'seoul.kr', 'ulsan.kr',
  // Mexico
  'com.mx', 'org.mx', 'net.mx', 'edu.mx', 'gob.mx',
  // Argentina
  'com.ar', 'org.ar', 'net.ar', 'gov.ar', 'edu.ar', 'mil.ar', 'int.ar', 'tur.ar',
  // Chile
  'co.cl', 'com.cl', 'org.cl', 'net.cl', 'gov.cl', 'mil.cl',
  // Colombia
  'com.co', 'org.co', 'net.co', 'gov.co', 'edu.co', 'mil.co', 'nom.co',
  // Venezuela
  'co.ve', 'com.ve', 'org.ve', 'net.ve', 'gov.ve', 'edu.ve', 'mil.ve', 'rec.ve', 'nom.ve',
  // Peru
  'com.pe', 'org.pe', 'net.pe', 'edu.pe', 'gob.pe', 'mil.pe', 'nom.pe',
  // Ecuador
  'com.ec', 'org.ec', 'net.ec', 'gov.ec', 'edu.ec', 'mil.ec', 'med.ec', 'fin.ec', 'pro.ec', 'info.ec',
  // Uruguay
  'com.uy', 'org.uy', 'net.uy', 'edu.uy', 'gub.uy', 'mil.uy',
  // Singapore
  'com.sg', 'org.sg', 'net.sg', 'gov.sg', 'edu.sg', 'per.sg',
  // Malaysia
  'com.my', 'org.my', 'net.my', 'gov.my', 'edu.my', 'mil.my', 'name.my',
  // Thailand
  'co.th', 'com.th', 'org.th', 'net.th', 'ac.th', 'go.th', 'in.th', 'mi.th',
  // Philippines
  'com.ph', 'org.ph', 'net.ph', 'gov.ph', 'edu.ph', 'mil.ph', 'ngo.ph',
  // Indonesia
  'co.id', 'com.id', 'org.id', 'net.id', 'ac.id', 'go.id', 'mil.id', 'or.id', 'sch.id', 'web.id',
  // Vietnam
  'com.vn', 'org.vn', 'net.vn', 'gov.vn', 'edu.vn', 'mil.vn', 'ac.vn', 'biz.vn', 'info.vn', 'name.vn', 'pro.vn', 'health.vn',
  // Hong Kong
  'com.hk', 'org.hk', 'net.hk', 'gov.hk', 'edu.hk', 'idv.hk',
  // Taiwan
  'com.tw', 'org.tw', 'net.tw', 'gov.tw', 'edu.tw', 'mil.tw', 'co.tw', 'idv.tw', 'game.tw', 'ebiz.tw', 'club.tw',
  // Pakistan
  'com.pk', 'org.pk', 'net.pk', 'gov.pk', 'edu.pk', 'mil.pk', 'biz.pk', 'web.pk', 'fam.pk', 'gob.pk', 'gok.pk', 'gon.pk', 'gop.pk', 'gos.pk',
  // Bangladesh
  'com.bd', 'org.bd', 'net.bd', 'gov.bd', 'edu.bd', 'mil.bd', 'ac.bd',
  // Sri Lanka
  'com.lk', 'org.lk', 'net.lk', 'gov.lk', 'edu.lk', 'mil.lk', 'ac.lk', 'grp.lk', 'hotel.lk', 'int.lk', 'ltd.lk', 'ngo.lk', 'sch.lk', 'soc.lk', 'web.lk',
  // Turkey
  'com.tr', 'org.tr', 'net.tr', 'gov.tr', 'edu.tr', 'mil.tr', 'biz.tr', 'info.tr', 'av.tr', 'dr.tr', 'gen.tr', 'k12.tr', 'name.tr', 'pol.tr', 'tel.tr', 'tsk.tr', 'tv.tr', 'web.tr',
  // Egypt
  'com.eg', 'org.eg', 'net.eg', 'gov.eg', 'edu.eg', 'mil.eg', 'sci.eg',
  // Nigeria
  'com.ng', 'org.ng', 'net.ng', 'gov.ng', 'edu.ng', 'mil.ng', 'mobi.ng', 'name.ng', 'sch.ng',
  // Kenya
  'co.ke', 'com.ke', 'org.ke', 'net.ke', 'gov.ke', 'edu.ke', 'mil.ke', 'ac.ke', 'go.ke', 'info.ke', 'me.ke', 'mobi.ke', 'ne.ke', 'or.ke', 'sc.ke',
  // Morocco
  'co.ma', 'com.ma', 'org.ma', 'net.ma', 'gov.ma', 'ac.ma', 'press.ma',
  // Saudi Arabia
  'com.sa', 'org.sa', 'net.sa', 'gov.sa', 'edu.sa', 'sch.sa', 'med.sa', 'pub.sa'
];
